<template>
  <div id="app" class="appPage"
       :class="{isMain: isMain, isMobile: isMobile, isMobileTop: isMobileTop, isFans: isFans}">
    <div class="web">
      <WebView></WebView>
    </div>
    <div class="mobile">
      <Header />
      <router-view></router-view>
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from '@/views/Header'
import Footer from '@/views/Footer'
import WebView from '@/views/Web.vue';

export default {
  name: 'App',
  components: {
    WebView,
    Header,
    Footer
  },
  data () {
    return {
      isMobile: true,
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
    this.$nextTick(() => {
      this.onResize()
    })
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 1100
    }
  },
  computed: {
    isMain () {
      return this.$route.name === 'main'
    },
    isMatch() {
      return this.$route.name === 'matchDetail';
    },
    isFans() {
      return this.$route.name === 'fansDetail';
    },
    isMobileTop () {
      switch (this.$route.name) {
        case 'matchDetail' :
          return true;
        case 'fansDetail' :
          return true;
        case 'playerDetail' :
          return true;
        default :
          return false;
      }
    }
  }
}
</script>
